import { FlowStatRecord, StatRecord } from "@dashboard-v3/api";
import reduce90Days from "../reduce90Days";

type Totals = ReturnType<typeof emptyResults>;

export type EmailFlowSumData = Array<{ date: number } & Totals>;

export function parseData(data: StatRecord[]): EmailFlowSumData {
  return reduce90Days<Totals>(data, "flow", emptyResults, (totals, stat) => {
    const record = stat as FlowStatRecord[];
    for (const { flow, total } of record) totals[flow] = total;
    return totals;
  });
}

function emptyResults() {
  return { in: 0, out: 0, both: 0 };
}
